import { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, Facebook, Instagram, Linkedin, Twitter, Link2 } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_be106047-7bc1-4755-b814-a58a16500b58/artifacts/p2la4lzy_ChatGPT%20Image%20Dec%2028%2C%202025%2C%2009_16_43%20PM.png";
const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const SOCIAL_ICONS = {
  facebook: Facebook,
  instagram: Instagram,
  linkedin: Linkedin,
  twitter: Twitter,
};

const Footer = () => {
  const [contact, setContact] = useState({ address: "", phone: "", email: "", social_links: [] });

  useEffect(() => {
    axios.get(`${API}/public/admin-contact`)
      .then(res => setContact(res.data || {}))
      .catch(() => {});
  }, []);

  const address = contact.address || "123 Travel Street, Holiday City, India";
  const phone = contact.phone || "+91 8699489969";
  const email = contact.email || "info@happyholidaysdmc.com";
  const phoneHref = `tel:${phone.replace(/\s+/g, '')}`;
  const socialLinks = (contact.social_links || []).filter(l => l && l.url);

  return (
    <footer className="bg-primary-900 text-white" data-testid="footer">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <img src={LOGO_URL} alt="Happy Holidays DMC" className="h-20 w-auto mb-4" />
            <p className="text-white/70 text-sm leading-relaxed">
              Your trusted B2B travel partner for unforgettable journeys. Making dream vacations a reality since 2010.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-heading text-lg text-secondary-500 mb-4">Quick Links</h4>
            <ul className="space-y-3">
              <li><Link to="/" className="text-white/70 hover:text-secondary-500 text-sm transition-colors">Home</Link></li>
              <li><Link to="/about" className="text-white/70 hover:text-secondary-500 text-sm transition-colors">About Us</Link></li>
              <li><Link to="/packages" className="text-white/70 hover:text-secondary-500 text-sm transition-colors">Packages</Link></li>
              <li><Link to="/contact" className="text-white/70 hover:text-secondary-500 text-sm transition-colors">Contact</Link></li>
            </ul>
          </div>

          {/* For Agents */}
          <div>
            <h4 className="font-heading text-lg text-secondary-500 mb-4">For Agents</h4>
            <ul className="space-y-3">
              <li><Link to="/agent-register" className="text-white/70 hover:text-secondary-500 text-sm transition-colors">Register as Agent</Link></li>
              <li><Link to="/login" className="text-white/70 hover:text-secondary-500 text-sm transition-colors">Agent Login</Link></li>
              <li><span className="text-white/70 text-sm">Request Quotes</span></li>
              <li><span className="text-white/70 text-sm">View Itineraries</span></li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h4 className="font-heading text-lg text-secondary-500 mb-4">Contact Us</h4>
            <ul className="space-y-3">
              <li className="flex items-start gap-3 text-white/70 text-sm" data-testid="footer-address">
                <MapPin className="w-4 h-4 mt-0.5 text-secondary-500 flex-shrink-0" />
                <span>{address}</span>
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm" data-testid="footer-phone">
                <Phone className="w-4 h-4 text-secondary-500 flex-shrink-0" />
                <a href={phoneHref} className="hover:text-secondary-500 transition-colors">{phone}</a>
              </li>
              <li className="flex items-center gap-3 text-white/70 text-sm" data-testid="footer-email">
                <Mail className="w-4 h-4 text-secondary-500 flex-shrink-0" />
                <a href={`mailto:${email}`} className="hover:text-secondary-500 transition-colors break-all">{email}</a>
              </li>
            </ul>
            {socialLinks.length > 0 && (
              <div className="flex gap-4 mt-6" data-testid="footer-social">
                {socialLinks.map((link, idx) => {
                  const Icon = SOCIAL_ICONS[link.platform] || Link2;
                  return (
                    <a
                      key={idx}
                      href={link.url}
                      target="_blank"
                      rel="noopener noreferrer"
                      aria-label={link.platform}
                      className="text-white/50 hover:text-secondary-500 transition-colors"
                      data-testid={`footer-social-${link.platform}`}
                    >
                      <Icon className="w-5 h-5" />
                    </a>
                  );
                })}
              </div>
            )}
          </div>
        </div>

        <div className="border-t border-white/10 mt-12 pt-8 text-center">
          <p className="text-white/50 text-sm">
            © 2025 Happy Holidays DMC. All rights reserved. | B2B Travel Company
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
